/**
 * Business Information Hook
 *
 * Reads company info from the Tenant model (single source of truth).
 * Used for footer, dashboard, and login page.
 */

import { useTenantStore } from '@/stores/tenantStore'

export interface BusinessInfo {
  name: string
  identification: string
  identification_type: string
  email: string
  phone: string
  address: string
}

/**
 * Hook to get business info from the tenant store (requires auth).
 * Returns the same shape as before for backward compatibility.
 */
export function useBusinessInfo() {
  const { tenant } = useTenantStore()

  const data: BusinessInfo | undefined = tenant
    ? {
        name: tenant.trade_name || tenant.name,
        identification: tenant.identification,
        identification_type: tenant.identification_type,
        email: tenant.email || '',
        phone: tenant.phone || '',
        address: tenant.address || '',
      }
    : undefined

  return {
    data,
    isLoading: !tenant,
    error: null,
  }
}

/**
 * Hook for public business info (login page, no auth).
 * Returns undefined since tenant data requires authentication.
 */
export function usePublicBusinessInfo() {
  return {
    data: undefined as BusinessInfo | undefined,
    isLoading: false,
    error: null,
  }
}
